import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { GlobalAssistencaTutelaInfoModalStyles } from './GlobalAssistanceTutelaModal.styles';
import {
  LeftSide, ModalBody, ModalContent, ModalHeader, RightSide, TextContainer, TitleBox,
} from './GlobalAssistencaStradaleModal.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';

function GlobalTutelaRiskModal({ setShowModal, quotation }) {
  const closeModal = () => setShowModal(false);

  return (
    <GlobalAssistencaTutelaInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <FontAwesomeIcon fontSize={34} icon={faTimes} cursor="pointer" onClick={() => closeModal()} />
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>
                Qui puoi controllare le informazioni su questa offerta.
              </p>
            </TextContainer>
          </LeftSide>
          <RightSide />
        </ModalHeader>
        <ModalContent>

          <div className="card-extra-information">
            {quotation.quote_type === 'immobile' && (
            <>
              <p>Copre controversie legate alla proprietà o conduzione della casa: difesa penale, liti condominiali, vertenze per lavori o manutenzioni e compravendite.</p>
              <p className="mt-3">
                <strong className="fw-bold">Massimale</strong>
                {' '}
                : fino a €50.000.
              </p>
            </>
            )}
            {quotation.quote_type === 'cyber_risk' && (
            <>
              <p>Tutela contro i rischi digitali. Copre difesa penale per reati online, frodi su e-commerce e azioni per rimuovere contenuti diffamatori dal web.</p>
              <p className="mt-3">
                <strong className="fw-bold">Massimale</strong>
                {' '}
                : fino a €50.000.
              </p>
            </>
            )}
            {quotation.quote_type === 'controversie_con_enti_pubblici' && (
            <>
              <p>Assistenza legale in caso di vertenze contro la pubblica amministrazione o aziende a partecipazione pubblica. Include ricorsi, risarcimenti e resistenza alle pretese di enti.</p>
              <p className="mt-3">
                <strong className="fw-bold">Massimale</strong>
                {' '}
                : fino a €50.000.
              </p>
            </>
            )}
            {quotation.quote_type === 'lavoro_dipendente' && (
            <>
              <p>Tutela legale per dipendenti pubblici o privati: difesa penale per fatti commessi sul lavoro e vertenze individuali sul rapporto lavorativo.</p>
              <p className="mt-3">
                <strong className="fw-bold">Massimale</strong>
                {' '}
                : fino a €50.000.
              </p>
            </>
            )}
            {quotation.quote_type === 'tutela_motor' && (
              <>
                <p>Copre le spese legali per incidenti stradali, sia come conducente che come pedone o ciclista. Include l’anticipo cauzionale all’estero.</p>
                <p className="mt-3">
                  <strong className="fw-bold">Massimale</strong>
                  {' '}
                  : fino a €100.000 in caso di lesioni gravi o omicidio stradale.
                </p>
              </>
            )}
            {quotation.quote_type === 'animali_domestici' && (
            <>
              <p>Tutela legale per controversie e danni legati agli animali domestici di famiglia. Copre difesa penale e richieste di risarcimento.</p>
              <p className="mt-3">
                <strong className="fw-bold">Massimale</strong>
                {' '}
                : fino a €50.000.
              </p>
            </>
            )}

          </div>
        </ModalContent>
      </ModalBody>
    </GlobalAssistencaTutelaInfoModalStyles>
  );
}

export default GlobalTutelaRiskModal;
